/**
 * Created by AB74296 on 9/5/2017.
 */
import React, { Component, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { HashRouter, Route, Navigate, Routes } from 'react-router-dom';
import { IdleTimerProvider }from 'react-idle-timer';
import BlockUi from '@availity/block-ui';
import PropTypes from 'prop-types';
import '@availity/block-ui/dist/index.css';
import LandingPage from '@/WA_TAP/LandingPage/LandingPage';
import MovingAttestation from '@/WA_TAP/MovingAttestation/MovingAttestation';
import Documentation from '@/WA_TAP/Documentation/Documentation';
import { Header } from '../components/index';
import ScrollToTop from '../utilities/scroll';
import commonStore from '../stores/commonStore';
import IdleTimeOutModal from '../components/IdleTimeOutModal';

import ReimbursementForm from '../../WA_TAP/ReimbursementForm/ReimbursementForm';
import ExpendituresInfo from '../../WA_TAP/ExpendituresInfo/ExpendituresInfo';
import ReviewSubmit from '../../WA_TAP/ReviewSubmit/ReviewSubmit';
import ConfirmationScreen from '../../WA_TAP/Confirmation/Confirmation';
import ReimbursementStore from '../../WA_TAP/stores/ReimbursementStore';




const timeout = 18 * 10 * 10000
const timeoutAlert = 9 * 10 * 10000
let overLayTimer = null

const IdleTimeoutContainer = () => {
  const [showModal, setShowModal] = useState(false)
  const idleTimer = useRef(null)

  const onActive = (e) => {
    if (idleTimer?.current?.getRemainingTime() > 0)
      // eslint-disable-next-line no-console
      console.log('user is active, time remaining::')
  }

  const onIdle = (e) => {
    setShowModal(true)
    overLayTimer = setTimeout(() => {
      window.location.reload()
      ReimbursementStore.resetReimbursementForm()
    }, timeoutAlert)
  }
  const handleClose = () => {
    setShowModal(false)
    window.location.reload()
    ReimbursementStore.resetReimbursementForm()
    clearTimeout(overLayTimer)
  }
  return (
    <>
      <IdleTimerProvider
        ref={idleTimer}
        element={document}
        onActive={onActive}
        onIdle={onIdle}
        debounce={250}
        timeout={parseInt(timeout - timeoutAlert, 10)} />
      <IdleTimeOutModal
        showModal={showModal}
        handleClose={handleClose}
      // handleLogout={handleLogout}
      />
    </>
  )
}
@observer
class Layout extends Component {
  constructor(props) {
    super(props);
    this.timerRef = null
  }
  defaultRender = () => <Navigate to="/" />;

  renderRootPath = () => {
    return (
      <>
        <Route  path="/" element={<LandingPage/>} />
        <Route  path="/reimbursementform" element={<ReimbursementForm/>} />
        <Route  path="/expendituresinfo" element={<ExpendituresInfo/>} />
        <Route  path="/movingattestation" element={<MovingAttestation/>} />
        <Route path="/documentation" element={<Documentation/>} />
        <Route  path="/reviewsubmit" element={<ReviewSubmit/>} />
        <Route  path="/confirmation" element={<ConfirmationScreen/>} />
      </>
    );
  };


  render() {
    return (
      <div>
        <IdleTimeoutContainer idleTimer={this.idleTimer} />
        <Header commonStore={commonStore} />
        <HashRouter basename="/">
          <div className="container">
            <BlockUi tag="div" blocking={ReimbursementStore.blocking}>
              <ScrollToTop />
              <Routes>
                {this.renderRootPath()}
              </Routes>
            </BlockUi>
          </div>
        </HashRouter>
      </div>
    );
  }
}

IdleTimeoutContainer.propTypes = {
  idleTimer: PropTypes.func
}

export default Layout;